import { integrationPlugin } from '@vue-storefront/core';

const moduleOptions = {};

export default integrationPlugin(({ app, integration }) => {
  integration.configure('sapcc', {
    ...moduleOptions,
    $cookies: app.$cookies,
    axios: {
      withCredentials: true
    }
  });
});
